import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import styles from "../RequestForQuotePage/index.module.css";
import GetWishlist from "./GetWishlist";
import GetSavedLater from "./GetSavedLater";
import { LoadingOverlay, Loader } from "react-overlay-loader";
import "../../black-box/custom.css";
import { Box, Card, CardContent, Typography } from "@material-ui/core";

const Tabs = () => {
    const [currentTab, setCurrentTab] = useState('1');
    const [setting, setSetting] = useState(false);

    const handleAppSetting = async () => {
        const requestOptions = {
            method: "POST",
            body: JSON.stringify({
                shop_domain: window.Shopify.shop
            })
        };
        const res = await fetch(
            `${process.env.REACT_APP_API_URL}` + "appSetting",
            requestOptions
        );
        const app_setting = await res.json();
        setSetting(app_setting.data);
    };

    useEffect(()=>{
        handleAppSetting();
    },[]);
    const content1 = (
        <GetSavedLater />
    );
    const content2 = (
        <GetWishlist />
    );
    const tabs = [
        {
            id: 1,
            tabTitle: 'Wishlists',
            content: content2
        },
        {
            id: 2,
            tabTitle: 'Saved for Later',
            content: content1
        }
    ];

    const handleTabClick = (e) => {
        setCurrentTab(e.target.id);
    }

    return (
        <div className='gf-tabs--container'>
            <div className='gf-main--tabs'>
                {setting != '' ?
                tabs.map((tab, i) =>
                    setting.save_for_later_option == "false" && tab.id == 2 ? "" :
                    <button key={i} id={tab.id} disabled={currentTab === `${tab.id}`} onClick={(handleTabClick)}>{tab.tabTitle}</button>
                )
                :''}
            </div>
            <div className='gf-tabs--content'>
                {tabs.map((tab, i) =>
                    <>
                        {currentTab === `${tab.id}` && <>{tab.content}</>}
                    </>
                )}
            </div>
        </div>
    );
}

export default Tabs;